const fieldTypesDefault = [
  {
    label: "Checkbox",
    value: "checkbox",
  },
  {
    label: "Date",
    value: "date",
  },
  {
    label: "Dropdown",
    value: "dropdown",
  },
  {
    label: "Conditional Text",
    value: "conditional_text",
  },
  {
    label: "Conditional Textarea",
    value: "conditional_textarea",
  },
  {
    label: "Conditional Textarea Rich",
    value: "conditional_textarea_rich",
  },
  {
    label: "Conditional Dropdown",
    value: "conditional_dropdown",
  },
  {
    label: "Conditional Checkbox",
    value: "conditional_checkbox",
  },
  {
    label: "Conditional Radio",
    value: "conditional_radio",
  },
  {
    label: "Conditional Number",
    value: "conditional_number",
  },
  {
    label: "Email",
    value: "email",
  },
  {
    label: "Text",
    value: "text",
  },
  {
    label: "Textarea",
    value: "textarea",
  },
  {
    label: "Textarea Rich",
    value: "textarea_rich",
  },
  {
    label: "Time",
    value: "time",
  },
  {
    label: "Number",
    value: "number",
  },
  {
    label: "Password",
    value: "password",
  },
  {
    label: "Radio",
    value: "radio",
  },
  {
    label: "Phone",
    value: "phone",
  },
  {
    label: "Zipcode",
    value: "zipcode",
  },
]

export default fieldTypesDefault
